import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  ApiResponse,
  ResetPasswordRecoveryPasswordCompleteApiNamespace,
  ResetPasswordRecoveryPasswordInitApiNamespace,
  ResetPasswordSetUserPasswordApiNamespace,
} from '@core/models/api';
import {
  BusinessMap,
  ResetPasswordSendOtpNamespace,
} from '@core/models/client';
import {
  AuthService,
  NavigationService,
  RecaptchaService,
  ResetPasswordHttpService,
  UIService,
} from '@core/services';
import {
  hasLength,
  hasLowerCase,
  hasNumbers,
  hasUpperCase,
  regexes,
} from '@core/utils';
import { TokenService } from '@paypoint-frontend/web-core';

@Injectable()
export class ResetPasswordService {
  private uiService = inject(UIService);
  private tokenService = inject(TokenService);
  private authService = inject(AuthService);
  private navigationService = inject(NavigationService);
  private http = inject(ResetPasswordHttpService);
  private recaptchaService = inject(RecaptchaService);

  form = new FormGroup({
    // requestKey: new FormControl(),
    login: new FormControl('', [
      Validators.required,
      Validators.pattern(regexes.EMAIL),
    ]),
    password: new FormControl('', [
      Validators.required,
      hasLength(),
      hasUpperCase(),
      hasLowerCase(),
      hasNumbers(),
    ]),
    passwordConfirm: new FormControl('', [
      Validators.required,
      Validators.pattern(regexes.PASSWORD),
    ]),
    token: new FormControl('', [
      Validators.required,
      Validators.pattern(regexes.PASSWORDTOKEN),
    ]),
  });

  businessFlow: BusinessMap;
  get token(): FormControl {
    return <FormControl>this.form.get('token');
  }

  sendOtpResponseOk = signal<ResetPasswordSendOtpNamespace.OUT>(
    new ResetPasswordSendOtpNamespace.OUT(),
  );
  sendOtpResponseError = signal<ApiResponse>(new ApiResponse());
  verifyOtpResponseError = signal<ApiResponse>(new ApiResponse());
  setPasswordResponseError = signal<ApiResponse>(new ApiResponse());
  resendOtpResponseOk = signal<ApiResponse>(new ApiResponse());
  resendOtpResponseError = signal<ApiResponse>(new ApiResponse());

  private clearSignals() {
    //this.sendOtpResponseOk.set(new ResetPasswordSendOtpNamespace.OUT());
    this.sendOtpResponseError.set(new ApiResponse());
    this.setPasswordResponseError.set(new ApiResponse());
    this.verifyOtpResponseError.set(new ApiResponse());
    this.resendOtpResponseOk.set(new ApiResponse());
    this.resendOtpResponseError.set(new ApiResponse());
  }

  init() {
    this.clearSignals();
    return new Promise<void>((resolve) => {
      this.uiService.freeze();
      this.navigationService.navigateToResetPasswordSetPassword();
      this.uiService.unFreeze();
      resolve();
    });
  }

  async setUserPasword(input: ResetPasswordSetUserPasswordApiNamespace.IN) {
    this.clearSignals();
    this.uiService.freeze();
    //input.captchaToken = await this.recaptchaService.captchaGetToken('submit');
    return new Promise<void>((resolve) => {
      this.http.setUserPassword(input).subscribe({
        next: () => {
          //this.sendOtpResponseOk.set(output);
          // this.requestKey.setValue(output.requestKey);
          //this.navigationService.navigateToResetPasswordOtp(output.requestKey);
          this.navigationService.loadToLogin();
          this.uiService.unFreeze();
          resolve();
        },
        error: (error: HttpErrorResponse) => {
          const response = new ApiResponse(error);
          this.setPasswordResponseError.set(response);
          console.log(response.message);
          this.uiService.unFreeze();
          resolve();
        },
      });
    });
  }

  async recoveryPasswordInit(
    input: ResetPasswordRecoveryPasswordInitApiNamespace.IN,
  ) {
    this.clearSignals();
    this.uiService.freeze();
    input.captchaToken =
      await this.recaptchaService.captchaGetToken('recoveryPassword');
    return new Promise<void>((resolve) => {
      this.http.recoveryPasswordInit(input).subscribe({
        next: () => {
          //this.sendOtpResponseOk.set(output);
          // this.requestKey.setValue(output.requestKey);
          this.navigationService.loadToLogin();
          this.uiService.unFreeze();
          resolve();
        },
        error: (error: HttpErrorResponse) => {
          const response = new ApiResponse(error);
          this.setPasswordResponseError.set(response);
          console.log(response.message);
          this.uiService.unFreeze();
          resolve();
        },
      });
    });
  }

  async recoveryPasswordComplete(
    input: ResetPasswordRecoveryPasswordCompleteApiNamespace.IN,
  ) {
    this.clearSignals();
    this.uiService.freeze();
    //input.captchaToken = await this.recaptchaService.captchaGetToken('submit');
    return new Promise<void>((resolve) => {
      this.http.recoveryPasswordComplete(input).subscribe({
        next: () => {
          //this.sendOtpResponseOk.set(output);
          // this.requestKey.setValue(output.requestKey);
          this.navigationService.loadToLogin();
          this.uiService.unFreeze();
          resolve();
        },
        error: (error: HttpErrorResponse) => {
          const response = new ApiResponse(error);
          this.setPasswordResponseError.set(response);
          console.log(response.message);
          this.uiService.unFreeze();
          resolve();
        },
      });
    });
  }
}
